import {Loader, Stack} from '@mantine/core'
import {useQuery} from '@tanstack/react-query'
import {createFileRoute} from '@tanstack/react-router'

import {getAssignedVsUnassigned} from 'src/api/client/api'
import AssignedUnassigned, {
    AssignedUnassignedExportContent,
} from 'src/components/analytics/assigned-unassigned'
import {useProspectNavigation} from 'src/components/analytics/use-prospect-navigation'
import {ExportImageButton} from 'src/components/export-image-button'
import {PageHeader} from 'src/components/page-header'
import {useScenarioPlanning} from 'src/components/scenario/scenario-context'

export const Route = createFileRoute('/_authed/organizations/$orgId/assigned-vs-unassigned')({
    component: AssignedVsUnassignedPage,
})

function AssignedVsUnassignedPage() {
    const {orgId} = Route.useParams()
    const navigateToProspects = useProspectNavigation(orgId)
    const {appliedScenario} = useScenarioPlanning()

    const {data, isLoading, error} = useQuery({
        queryKey: ['page', orgId, 'assigned-vs-unassigned', appliedScenario],
        queryFn: () => getAssignedVsUnassigned(orgId, appliedScenario),
    })

    if (isLoading) {
        return <Loader size="lg" style={{display: 'block', margin: '60px auto'}} />
    }

    if (error) {
        return <div>Error loading page: {(error as Error).message}</div>
    }

    if (!data) return null

    const headerTitle = 'Assigned vs Unassigned'
    const headerDescription = 'Prospect distribution between assigned and unassigned portfolios.'

    return (
        <Stack>
            <PageHeader
                title={headerTitle}
                description={headerDescription}
                actions={
                    <ExportImageButton
                        title={headerTitle}
                        renderContent={() => <AssignedUnassignedExportContent data={data} />}
                        filenameBase="assigned-vs-unassigned"
                        kinds={['table']}
                    />
                }
            />
            <AssignedUnassigned data={data} onProspectFilter={navigateToProspects} />
        </Stack>
    )
}
